(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s97-origin"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  var Lightbox = {
    el: null, holder: null, cap: null, btns: [], i: 0, lastFocus: null,
    ensure: function () {
      if (this.el) return;
      var o = document.createElement('div');
      o.className = 's97-lb';
      o.hidden = true;
      o.setAttribute('role', 'dialog');
      o.setAttribute('aria-modal', 'true');
      o.setAttribute('aria-label', 'Producer photo');
      o.innerHTML =
        '<button type="button" class="s97-lb__close" aria-label="Close">×</button>' +
        '<button type="button" class="s97-lb__nav s97-lb__prev" aria-label="Previous photo">‹</button>' +
        '<div class="s97-lb__stage"><div class="s97-lb__holder"></div><p class="s97-lb__cap"></p></div>' +
        '<button type="button" class="s97-lb__nav s97-lb__next" aria-label="Next photo">›</button>';
      document.body.appendChild(o);
      this.el = o;
      this.holder = o.querySelector('.s97-lb__holder');
      this.cap = o.querySelector('.s97-lb__cap');
      var self = this;
      o.querySelector('.s97-lb__close').addEventListener('click', function () { self.close(); });
      o.querySelector('.s97-lb__prev').addEventListener('click', function () { self.step(-1); });
      o.querySelector('.s97-lb__next').addEventListener('click', function () { self.step(1); });
      o.addEventListener('click', function (e) { if (e.target === o) self.close(); });
      document.addEventListener('keydown', function (e) {
        if (self.el.hidden) return;
        if (e.key === 'Escape') self.close();
        else if (e.key === 'ArrowLeft') self.step(-1);
        else if (e.key === 'ArrowRight') self.step(1);
      });
    },
    open: function (btns, index) {
      this.ensure();
      this.btns = btns; this.i = index;
      this.lastFocus = document.activeElement;
      this.render();
      this.el.hidden = false;
      document.body.style.overflow = 'hidden';
      this.el.querySelector('.s97-lb__close').focus();
    },
    render: function () {
      var b = this.btns[this.i];
      var cap = b.getAttribute('data-caption') || '';
      var full = b.getAttribute('data-full');
      var ph = b.getAttribute('data-ph');
      this.holder.innerHTML = '';
      if (full) {
        var img = document.createElement('img');
        img.className = 's97-lb__img';
        img.src = full; img.alt = cap || 'Producer photo';
        this.holder.appendChild(img);
      } else {
        var panel = document.createElement('div');
        panel.className = 's97-lb__panel ' + (ph || '');
        var lbl = document.createElement('span');
        lbl.className = 's97-slide__phlabel';
        lbl.textContent = 'Producer photo';
        panel.appendChild(lbl);
        this.holder.appendChild(panel);
      }
      this.cap.textContent = cap;
      this.cap.hidden = cap.length === 0;
      var single = this.btns.length < 2;
      this.el.querySelector('.s97-lb__prev').hidden = single;
      this.el.querySelector('.s97-lb__next').hidden = single;
    },
    step: function (d) {
      this.i = (this.i + d + this.btns.length) % this.btns.length;
      this.render();
    },
    close: function () {
      this.el.hidden = true;
      document.body.style.overflow = '';
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
  };

  class S97Slideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.s97-slide'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.s97-slides__dot'));
      this.btns = Array.prototype.slice.call(this.querySelectorAll('.s97-slide__btn'));
      this.i = 0;
      this.timer = null;
      this.ms = parseInt(this.getAttribute('data-interval'), 10) || 5000;
      if (this.slides.length <= 1) this.setAttribute('data-single', '');
      this.show(0);
      var self = this;
      var prev = this.querySelector('.s97-slides__prev');
      var next = this.querySelector('.s97-slides__next');
      if (prev) prev.addEventListener('click', function () { self.go(self.i - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.i + 1); });
      this.dots.forEach(function (d, n) { d.addEventListener('click', function () { self.go(n); }); });
      this.btns.forEach(function (b, n) { b.addEventListener('click', function () { Lightbox.open(self.btns, n); }); });
      this.addEventListener('mouseenter', function () { self.stop(); });
      this.addEventListener('mouseleave', function () { self.start(); });
      this.addEventListener('focusin', function () { self.stop(); });
      this.addEventListener('focusout', function () { self.start(); });
      if (reduce.matches === false) this.start();
      reduce.addEventListener('change', function (e) { e.matches ? self.stop() : self.start(); });
    }
    disconnectedCallback() { this.stop(); }
    show(n) {
      this.slides.forEach(function (s, k) {
        var on = k === n;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      this.dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === n);
        d.setAttribute('aria-current', k === n ? 'true' : 'false');
      });
      this.btns.forEach(function (b, k) { b.tabIndex = (k === n) ? 0 : -1; });
      this.i = n;
    }
    go(n) {
      var t = (n + this.slides.length) % this.slides.length;
      this.show(t);
      this.restart();
    }
    start() {
      if (reduce.matches || this.slides.length <= 1) return;
      this.stop();
      var self = this;
      this.timer = window.setInterval(function () { self.go(self.i + 1); }, this.ms);
    }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    restart() { this.stop(); this.start(); }
  }
  if (customElements.get('s97-slideshow') === undefined) customElements.define('s97-slideshow', S97Slideshow);
})();

  } catch(e) { console.error(e); }
})();
})();
